import React from 'react';
import { useTranslation } from 'react-i18next';
import { Order } from '@/types/order';
import Grid, { itemText } from '@/components/molecules/section/Grid';
import Container from '@/components/molecules/section/Container';
import { transformDateStringFrance } from '@/utilities/datetime';

const View: React.FC<{ order: Order }> = ({ order }) => {
  const { t } = useTranslation();

  const paymentInfo = order.paymentInfo;

  const items = [
    itemText(t('order.buyer_payment.payment_status'), paymentInfo?.status),
    itemText(t('order.buyer_payment.authorized'), paymentInfo?.toBeCapturedAmountInfo),
    itemText(t('order.buyer_payment.captured'), paymentInfo?.capturedAmountInfo),
    itemText(t('order.buyer_payment.cancelled'), transformDateStringFrance(paymentInfo?.cancelledAt)),
    itemText(t('order.buyer_payment.last_update'), transformDateStringFrance(paymentInfo?.updatedAt)),
    itemText(t('order.buyer_payment.validation_type'), paymentInfo?.validationTypeForFraud),
    itemText(t('order.buyer_payment.payment_method'), paymentInfo?.paymentMethod),
    itemText(t('order.buyer_payment.card_type'), paymentInfo?.cardType),
    itemText(t('order.buyer_payment.notes'), paymentInfo?.notes),
    itemText(t('order.buyer_payment.notes_cancellation'), paymentInfo?.notesCancellation),
  ];

  return (
    <Container
      title={t('order.buyer_payment.title')}
      actions={[]}
      testId="buyer_payment"
    >
      <Grid
        column={5}
        items={items}
      />
    </Container>
  );
};

export default View;
